<template>
	<section class="">
		
		<header class="navbar navbar-expand-lg navbar-dark bg-dark">
			<div class="container">
				<div class="logo col-6 col-md-3">
					<img src="https://hviorder.ca/img/hvi-logo-ots.svg" class="img-fluid">
				</div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav" >
					<span class="navbar-toggler-icon"></span>
				</button>
				
				<div class="collapse navbar-collapse" id="nav">
					<ul class="navbar-nav mr-auto">
						<a href="" class="nav-link nav-item">How It Works</a>
						<a href="" class="nav-link nav-item">Features</a>
						<a href="" class="nav-link nav-item">Mobile</a>
					
					</ul>
				
				</div>
				
				<div class="auth d-none d-md-block">
					<button class="btn btn-primary  mr-3">Sign Up</button>
					<button class="btn btn-outline-light">Login</button>
				</div>
			</div>
	
		</header>
		
		<header class="navbar navbar-dark bg-dark">
			<div class="container">
			
				<!--Nav-->
				<nav class="nav">
				
				</nav>
				<!--Auth Functions-->
			
			
			</div>
		
		</header>
	</section>

</template>

<script>
	export default {
		name: 'NavBar',
		data () {
			return {}
		}
	}
</script>
